import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { logout, getUser } from '../lib/auth'

export default function Navbar() {
  const navigate = useNavigate()
  const user = getUser()

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  return (
    <nav className="border-b-[3px] border-ink bg-paper">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Link to="/dashboard" className="flex items-center gap-2 shrink-0 min-w-0">
          <img src="/logo-mark.png" alt="" className="h-8 w-8 sm:h-9 sm:w-9" />
          <span className="text-base sm:text-xl font-extrabold tracking-tight text-ink">MyWrenchLog</span>
        </Link>
        <div className="flex items-center gap-4 sm:gap-6 text-sm font-semibold">
          {user?.name && <span className="hidden md:inline text-muted font-normal">{user.name}</span>}
          <Link to="/dashboard" className="text-ink hover:underline underline-offset-4">Garage</Link>
          <Link to="/account" className="text-muted hover:text-ink hover:underline underline-offset-4">Account</Link>
          <button onClick={handleLogout} className="text-muted hover:text-ink hover:underline underline-offset-4">
            Log out
          </button>
        </div>
      </div>
    </nav>
  )
}
